module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.userFullName && _vm.subMenuItems.length > 0) ? [_c('b-dropdown-divider'), _vm._l((_vm.subMenuItems), function(item) {
    return [(item.to) ? _c('b-nav-item', {
      attrs: {
        "to": item.to
      }
    }, [_vm._v(_vm._s(item.text))]) : (item.href) ? _c('b-nav-item', {
      attrs: {
        "href": item.href,
        "target": item.target ? item.target : '_self'
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()]
  })] : _vm._e(), (_vm.showLanguageSelector) ? [(_vm.userFullName && _vm.subMenuItems.length > 0) ? _c('b-dropdown-divider') : _vm._e(), _vm._l((_vm.availableLanguages), function(code) {
    return _c('b-dropdown-item', {
      key: code,
      class: {
        selected: _vm.language === code
      },
      attrs: {
        "name": _vm.getLanuageLink(code)
      },
      on: {
        "click": function($event) {
          _vm.localeSelect(code)
        }
      }
    }, [_vm._v(_vm._s(_vm.localeInNativeName(code, 'locale_native_name'))), _c('icon', {
      attrs: {
        "name": "check"
      }
    })], 1)
  })] : _vm._e(), (_vm.userFullName && !_vm.hideLogout) ? [_c('b-dropdown-divider'), _c('div', {
    staticClass: "additional menu-box"
  }, [_c('b-button', {
    staticClass: "btn-block btn-logout",
    attrs: {
      "variant": "success",
      "name": "link_header_to_singout"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.header.signout')))])], 1)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dbe3b1f"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/header/submenu/Submenu.vue
// module id = 2052
// module chunks = 1